import { ReactNode } from "react";
import { Grid, GridSpacing, Typography } from "@mui/material";
import { GridProps } from "@mui/material/Grid";
import { FormBorder } from "./FormBorder";

type BorderedFormGridProps = {
  children?: ReactNode;
  columnSpacing?: GridSpacing;
  rowSpacing?: GridSpacing;
  width?: string;
  subformName?: string;
};

export const BorderedFormGrid = ({
  children,
  columnSpacing = 3,
  rowSpacing = 4,
  width = "100%",
  subformName,
  ...otherProps
}: BorderedFormGridProps & GridProps) => {
  return (
    <>
      {subformName && (
        <Typography sx={{ fontWeight: "bold", mb: "-1rem", mt: "1.5rem" }}>
          {subformName}
        </Typography>
      )}
      <FormBorder>
        <Grid
          container
          columnSpacing={columnSpacing}
          rowSpacing={rowSpacing}
          {...otherProps}
          sx={{
            width,
          }}
        >
          {children}
        </Grid>
      </FormBorder>
    </>
  );
};
